import { SEND_EMAIL, clearFeedback } from './feedbackActions';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getAuth } from 'actions/auth/login';
import { getFeedbackMessage } from './feedbackSelectors';
import { getLocale } from 'actions/language/selectors';
import { pushAttentionNotification } from 'actions/notification/notification';
import { pushFormattedError } from 'helpers/formValidationHelper/formValidationMessage';
import { sendFeedback } from 'api/messages';

/*** Send Message ***/
// Worker
export function* sendFeedbackWorker() {
  try {
    const locale = yield select(getLocale);
    const auth = yield select(getAuth);
    const message = yield select(getFeedbackMessage);
    yield call(sendFeedback, locale, auth, message);
    yield put(
      pushAttentionNotification({
        title: 'Success',
        messages: 'Feedback Sent'
      })
    );
    yield put(clearFeedback());
  } catch (err) {
    yield pushFormattedError(err);
  }
}

// Watcher
export function* sendFeedbackSaga() {
  yield takeLatest(SEND_EMAIL, sendFeedbackWorker);
}



// WEBPACK FOOTER //
// ./src/actions/communication/feedback/feedbackSagas.js